import axios from "axios";

export type RealtimeEmailVariant = "bidReceived" | "intentReceivedAccepted" | "intentReceivedDeclined";

class ServiceScheduledEmailsController {
  async sendTestSupplierInsuranceReminder(email: string) {
    const response = await axios.post(
      "/api/scheduledEmails/test/supplierInsuranceReminder",
      { email },
    );
    return response.data as { success: boolean; message: string };
  }

  async sendTestRealtimeEmail(email: string, variant: RealtimeEmailVariant, viaQueue: boolean) {
    const response = await axios.post(
      "/api/scheduledEmails/test/realtimeEmail",
      { email, variant, viaQueue },
    );
    return response.data as { success: boolean; message: string };
  }

  async sendTestMessageDigest(email: string) {
    const response = await axios.post(
      "/api/scheduledEmails/test/messageDigest",
      { email },
    );
    return response.data as { success: boolean; message: string };
  }
}

export const ServiceScheduledEmails = new ServiceScheduledEmailsController();
